"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("./actions");

var _constants = require("./constants");

var _DoiPage = _interopRequireDefault(require("./DoiPage"));

var _handleActions;

var initalState = new _immutable.Map();

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchDoiPagesActionTypes.SUCCESS, function (state, action) {
  return state.withMutations(function (map) {
    action.payload.data.reduce(function (acc, item) {
      var page = new _DoiPage.default(item);
      return acc.set(page.get(_constants.ID), page);
    }, map);
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.UpdateDoiPageActionTypes.SUCCESS, function (state, action) {
  var page = new _DoiPage.default(action.payload.props);
  var id = page.get(_constants.ID);

  if (!page.get(_constants.ACTIVE)) {
    return state.remove(id);
  } else {
    return state.set(id, page);
  }
}), _handleActions), initalState);

exports.default = _default;
module.exports = exports.default;